import {
  DISPOSITIVOPACIENTE_ERROR,
  DISPOSITIVOPACIENTE_LOADING,
  DISPOSITIVOPACIENTE_RESET,
  DISPOSITIVOPACIENTE_SUCCESS,
  DISPOSITIVOPACIENTEDELETE_LOADING,
  DISPOSITIVOPACIENTEDELETE_SUCCESS,
  DISPOSITIVOPACIENTEDELETE_ERROR,
  DISPOSITIVOPACIENTEAGREGAR_LOADING,
  DISPOSITIVOPACIENTEAGREGAR_SUCCESS,
  DISPOSITIVOPACIENTEAGREGAR_ERROR,
  DISPOSITIVOPACIENTEAGREGAR_RESET,
  DISPOSITIVOPACIENTE_FLGVINCULADO,
  DISPOSITIVOPACIENTEDELETE_RESET,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";

export const wsGetDispositivoPaciente = () => (dispatch) => {
  dispatch({
    type: DISPOSITIVOPACIENTE_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .get("/dispositivoPaciente")
      .then((res) => {
        dispatch({
          type: DISPOSITIVOPACIENTE_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "portal",
        };

        dispatch({
          type: DISPOSITIVOPACIENTE_ERROR,
          payload: error,
        });
      });
  });
};

export const wsPostDispositivoPaciente = (dtoDispositivo) => (dispatch) => {
  dispatch({
    type: DISPOSITIVOPACIENTEAGREGAR_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .post("/dispositivoPaciente", dtoDispositivo)
      .then((res) => {
        dispatch({
          type: DISPOSITIVOPACIENTEAGREGAR_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "portal",
          status: err.response?.status,
          statusText: err.response?.statusText,
        };

        dispatch({
          type: DISPOSITIVOPACIENTEAGREGAR_ERROR,
          payload: error,
        });
      });
  });
};

export const wsDeleteDispositivoPaciente = () => (dispatch) => {
  dispatch({
    type: DISPOSITIVOPACIENTEDELETE_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .delete("/dispositivoPaciente")
      .then((res) => {
        dispatch({
          type: DISPOSITIVOPACIENTEDELETE_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "portal",
        };

        dispatch({
          type: DISPOSITIVOPACIENTEDELETE_ERROR,
          payload: error,
        });
      });
  });
};

export const dispositivoPacienteReset = () => (dispatch) => {
  dispatch({
    type: DISPOSITIVOPACIENTE_RESET,
  });
};

export const dispositivoPacienteFlgVinculadoSetTrue = () => (dispatch) => {
  dispatch({
    type: DISPOSITIVOPACIENTE_FLGVINCULADO,
  });
};

export const dispositivoPacienteDeleteReset = () => (dispatch) => {
  dispatch({
    type: DISPOSITIVOPACIENTEDELETE_RESET,
  });
};

export const dispositivoPacientePostReset = () => (dispatch) => {
  dispatch({
    type: DISPOSITIVOPACIENTEAGREGAR_RESET,
  });
};
